// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgListviewCard24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11 6C11 4.34315 9.65685 3 8 3H5C3.34315 3 2 4.34315 2 6V8C2 9.65685 3.34315 11 5 11H8C9.65685 11 11 9.65685 11 8V6ZM5 4.5H8C8.82843 4.5 9.5 5.17157 9.5 6V8C9.5 8.82843 8.82843 9.5 8 9.5H5C4.17157 9.5 3.5 8.82843 3.5 8V6C3.5 5.17157 4.17157 4.5 5 4.5Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22 6C22 4.34315 20.6569 3 19 3H16C14.3431 3 13 4.34315 13 6V8C13 9.65685 14.3431 11 16 11H19C20.6569 11 22 9.65685 22 8V6ZM16 4.5H19C19.8284 4.5 20.5 5.17157 20.5 6V8C20.5 8.82843 19.8284 9.5 19 9.5H16C15.1716 9.5 14.5 8.82843 14.5 8V6C14.5 5.17157 15.1716 4.5 16 4.5Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M11 16C11 14.3431 9.65685 13 8 13H5C3.34315 13 2 14.3431 2 16V18C2 19.6569 3.34315 21 5 21H8C9.65685 21 11 19.6569 11 18V16ZM5 14.5H8C8.82843 14.5 9.5 15.1716 9.5 16V18C9.5 18.8284 8.82843 19.5 8 19.5H5C4.17157 19.5 3.5 18.8284 3.5 18V16C3.5 15.1716 4.17157 14.5 5 14.5Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M22 16C22 14.3431 20.6569 13 19 13H16C14.3431 13 13 14.3431 13 16V18C13 19.6569 14.3431 21 16 21H19C20.6569 21 22 19.6569 22 18V16ZM16 14.5H19C19.8284 14.5 20.5 15.1716 20.5 16V18C20.5 18.8284 19.8284 19.5 19 19.5H16C15.1716 19.5 14.5 18.8284 14.5 18V16C14.5 15.1716 15.1716 14.5 16 14.5Z"
				/>
			</Svg>
		);
	}
);
SvgListviewCard24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgListviewCard24;
